import PropTypes from 'prop-types';
import React from 'react';
import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from 'reactstrap';

import history from '../../../utils/history';
import { formatAccuracy, formatNumber } from '../../../utils/numberFormatter';
import { setSessionStorageItem } from '../../../utils/sessionStorage';
import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import { QuizDisabledTooltip } from '../../Common/CommonDailysQuiz/QuizDisabledTooltip';
import { Desktop, Mobile } from '../../Common/const';

class DailyQuizHistoryView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSelectOption: '',
      dropdownIsOpen: false,
      historyHovered: false,
      isLoadingdaily20: true,
      isRetake: false,
      dailyQuizIncomplete: null,
    };
    this.handleDopdownClick = this.handleDopdownClick.bind(this);
    this.handelSelectOnClick = this.handelSelectOnClick.bind(this);
    this.initialitateSelectDefaultOption =
      this.initialitateSelectDefaultOption.bind(this);
    this.setLocalStorage = this.setLocalStorage.bind(this);
  }

  handleDopdownClick() {
    this.setState({ dropdownIsOpen: !this.state.dropdownIsOpen });
  }

  handelSelectOnClick(e) {
    this.setState({ dropdownIsOpen: !this.state.dropdownIsOpen });
    const name = e.target.name;
    const value = e.target.value;

    this.setState({ currentSelectOption: name });
    window.localStorage.setItem('optionSelectLQuizHistory', value);
  }

  initialitateSelectDefaultOption(option) {
    switch (option) {
      case 'score':
        this.setState({ currentSelectOption: 'SCORE' });
        break;
      case 'average':
        this.setState({ currentSelectOption: 'AVERAGE' });
        break;
      case 'earned':
        this.setState({ currentSelectOption: 'EARNED' });
        break;
      default:
        this.setState({ currentSelectOption: '' });
    }
  }

  setLocalStorage() {
    let optionSelect = window
      ? window.localStorage.getItem('optionSelectLQuizHistory')
      : '';
    if (!optionSelect) {
      optionSelect = window.localStorage.setItem(
        'optionSelectLQuizHistory',
        'score',
      );
      optionSelect = 'score';
    }

    this.initialitateSelectDefaultOption(optionSelect);
  }

  componentDidMount() {
    this.setLocalStorage();
    this.firstLoad();
  }

  componentDidUpdate(prevProps) {
    const { oneDailyQuizHistory } = this.props;
    if (this.state.isRetake && this.state.idDailyQuiz) {
      history.push({
        pathname: '/app/daily20quiz',
        state: { isRetake: true, idDailyQuiz: this.state.idDailyQuiz },
      });
    } else if (
      prevProps.oneDailyQuizHistory !== oneDailyQuizHistory &&
      !this.state.isLoadingdaily20 &&
      !this.state.isRetake
    ) {
      if (oneDailyQuizHistory.questions.length === 0) {
        this.setState({ dailyQuizIncomplete: oneDailyQuizHistory.id });
      } else {
        this.setState({ isLoadingdaily20: true });
        setSessionStorageItem('quiz', JSON.stringify(oneDailyQuizHistory));
        history.push('/app/daily20quizReview');
      }
    }
  }

  firstLoad = () => {
    this.props.getDailyQuizHistory(0, 3, true);
  };

  handleLoadMore = () => {
    if (
      this.props.dailyQuizHistory.dailyHistoryList.length <
      this.props.dailyQuizHistory.totalHistoryItems
    ) {
      this.props.getDailyQuizHistory(
        this.props.dailyQuizHistory.dailyHistoryList.length,
        3,
      );
    }
  };

  convertDate(date) {
    const dateNumber = Number(date);
    const auxDate = new Date(dateNumber);
    const month = auxDate.getMonth();
    let stringMonth = '';
    switch (month) {
      case 0:
        stringMonth = 'January';
        break;
      case 1:
        stringMonth = 'February';
        break;
      case 2:
        stringMonth = 'March';
        break;
      case 3:
        stringMonth = 'April';
        break;
      case 4:
        stringMonth = 'May';
        break;
      case 5:
        stringMonth = 'June';
        break;
      case 6:
        stringMonth = 'July';
        break;
      case 7:
        stringMonth = 'August';
        break;
      case 8:
        stringMonth = 'September';
        break;
      case 9:
        stringMonth = 'October';
        break;
      case 10:
        stringMonth = 'November';
        break;
      case 11:
        stringMonth = 'December';
        break;

      default:
        stringMonth = 'Non Month';
    }
    const stringDate = `${stringMonth} ${auxDate.getDate()}, ${auxDate.getFullYear()}`;
    return stringDate;
  }

  handleReviewDailyQuiz(id) {
    this.props.getOneDailyQuizHistory(id);
    this.setState({ isLoadingdaily20: false, isRetake: false });
  }

  handleRetakeDailyQuiz(id) {
    this.setState({ isRetake: true, idDailyQuiz: id });
  }

  handleReviewLastDailyQuiz(id) {
    this.props.getOneDailyQuizHistory(id, true);
    this.setState({ isLoadingdaily20: false, isRetake: false });

    setSessionStorageItem('isReviewingLastDailyQuiz', JSON.stringify(true));
  }

  renderHistoryDesktop() {
    const dailyInRetakeId = this.props.dailyQuizHistory?.dailyInRetakeId;
    const isDailyQuizActive = this.props.dailyQuizHistory?.isDailyQuizActive;
    const { dailyHistoryList } = this.props.dailyQuizHistory;
    const inProgress = dailyHistoryList.some(
      (item) => item.id === dailyInRetakeId,
    );

    const quizHistory = dailyHistoryList.map((item, index) => {
      const isInProgress = item.id === dailyInRetakeId;

      let disabledRetakeButton = Boolean(dailyInRetakeId && !isInProgress);

      let disabledReviewButton = Boolean(inProgress);

      if (isDailyQuizActive) {
        disabledRetakeButton = true;
        disabledReviewButton = true;
      }

      let myScore;
      let average;
      if (this.state.historyHovered) {
        myScore = `${item.correctAnwers}/${item.totalQuiz}`;
        average = `${item.averageCorrectAnswers}/${item.totalQuiz}`;
      } else {
        myScore = `${formatAccuracy((item.correctAnwers / item.totalQuiz) * 100)}%`;
        average = `${formatAccuracy((item.averageCorrectAnswers / item.totalQuiz) * 100)}%`;
      }
      return (
        <React.Fragment key={item.id}>
          {disabledRetakeButton && disabledReviewButton && (
            <QuizDisabledTooltip />
          )}
          <div className="m-0 p-0">
            <Row className="history-row">
              <Col xs={5} md={7} className="d-flex">
                <p className="mt-auto mb-auto">{this.convertDate(item.date)}</p>
                <button
                  className="btn btn-outline-secondary rounded-lg ml-3 my-auto"
                  onClick={() => this.handleReviewDailyQuiz(item.id)}
                  disabled={disabledReviewButton}
                >
                  REVIEW
                </button>
                <button
                  className="btn btn-outline-secondary rounded-lg ml-3 my-auto pe-btn"
                  onClick={() => this.handleRetakeDailyQuiz(item.id)}
                  disabled={disabledRetakeButton}
                >
                  {isInProgress ? (
                    <span className="font-italic"> In progress </span>
                  ) : (
                    <span>RE-TAKE</span>
                  )}
                </button>
              </Col>
              <Col xs={7} md={5}>
                <Row
                  onMouseEnter={() => {
                    this.setState({ historyHovered: true });
                  }}
                  onMouseLeave={() => {
                    this.setState({ historyHovered: false });
                  }}
                >
                  <Col xs={3} className="d-flex">
                    <button
                      className="btn btn-outline-secondary rounded-lg m-auto m-btn"
                      onClick={() => this.handleReviewLastDailyQuiz(item.id)}
                      disabled={disabledReviewButton}
                    >
                      REVIEW
                    </button>
                  </Col>
                  <Col xs={3} className="d-flex">
                    <p className="m-auto">{myScore}</p>
                  </Col>
                  <Col xs={3} className="d-flex">
                    <p className="m-auto">{average}</p>
                  </Col>
                  <Col xs={3} className="d-flex">
                    <p className="m-auto">{formatNumber(item.earned)}pts</p>
                  </Col>
                </Row>
              </Col>
            </Row>
            {dailyHistoryList.length !== index + 1 && (
              <hr className="row-divider" />
            )}
            {this.state.dailyQuizIncomplete === item.id && (
              <div className="alert text-center p-3">
                Review is unavailable for incomplete daily quizzes.
              </div>
            )}
          </div>
        </React.Fragment>
      );
    });
    return quizHistory;
  }

  renderHistoryMobile(selectOption) {
    const dailyInRetakeId = this.props.dailyQuizHistory?.dailyInRetakeId;
    const isDailyQuizActive = this.props.dailyQuizHistory?.isDailyQuizActive;
    const { dailyHistoryList } = this.props.dailyQuizHistory;
    const inProgress = dailyHistoryList.some(
      (item) => item.id === dailyInRetakeId,
    );

    const quizHistory = dailyHistoryList.map((item, index) => {
      const isInProgress = item.id === dailyInRetakeId;

      let disabledRetakeButton = Boolean(
        !item.resultsDetailed || (dailyInRetakeId && !isInProgress),
      );

      let disabledReviewButton = Boolean(!item.resultsDetailed || inProgress);

      if (isDailyQuizActive) {
        disabledRetakeButton = true;
        disabledReviewButton = true;
      }

      switch (selectOption) {
        case 'SCORE':
          const myScore = this.state.historyHovered
            ? `${item.correctAnwers}/${item.totalQuiz}`
            : `${formatAccuracy((item.correctAnwers / item.totalQuiz) * 100)}%`;

          return (
            <React.Fragment key={item.id}>
              {disabledRetakeButton && disabledReviewButton && (
                <QuizDisabledTooltip />
              )}
              <div className="m-0 p-0">
                <Row className="history-row">
                  <Col xs={8} className="d-flex m-btn-container">
                    <p className="mt-auto mb-auto">
                      {this.convertDate(item.date)}
                    </p>
                  </Col>
                  <Col
                    xs={4}
                    className="d-flex"
                    onMouseEnter={() => {
                      this.setState({ historyHovered: true });
                    }}
                    onMouseLeave={() => {
                      this.setState({ historyHovered: false });
                    }}
                  >
                    <p className="m-auto">{myScore}</p>
                  </Col>
                </Row>
                <div className="buttons-quiz-container">
                  <button
                    className="btn btn-outline-secondary rounded-lg ml-auto my-auto m-btn mobile-quiz-button"
                    onClick={() => this.handleRetakeDailyQuiz(item.id)}
                    disabled={disabledRetakeButton}
                  >
                    {isInProgress ? (
                      <span className="font-italic"> In progress </span>
                    ) : (
                      <span>RE-TAKE</span>
                    )}
                  </button>
                  <button
                    className="btn btn-outline-secondary rounded-lg ml-auto my-auto m-btn mobile-quiz-button"
                    onClick={() => this.handleReviewDailyQuiz(item.id)}
                    disabled={disabledReviewButton}
                  >
                    REVIEW
                  </button>
                  <button
                    className="btn btn-outline-secondary rounded-lg ml-auto my-auto m-btn mobile-quiz-button"
                    onClick={() => this.handleReviewLastDailyQuiz(item.id)}
                    disabled={disabledReviewButton}
                  >
                    REVIEW LAST QUIZ
                  </button>
                </div>
                {dailyHistoryList.length !== index + 1 && (
                  <hr className="row-divider" />
                )}
                {this.state.dailyQuizIncomplete === item.id && (
                  <div className="alert text-center p-3">
                    Review is unavailable for incomplete daily quizzes.
                  </div>
                )}
              </div>
            </React.Fragment>
          );
        case 'AVERAGE':
          const average = this.state.historyHovered
            ? `${item.averageCorrectAnswers}/${item.totalQuiz}`
            : `${formatAccuracy((item.averageCorrectAnswers / item.totalQuiz) * 100)}%`;
          return (
            <React.Fragment key={item.id}>
              {disabledRetakeButton && disabledReviewButton && (
                <QuizDisabledTooltip />
              )}
              <div className="m-0 p-0">
                <Row className="history-row">
                  <Col xs={8} className="d-flex m-btn-container">
                    <p className="mt-auto mb-auto">
                      {this.convertDate(item.date)}{' '}
                    </p>
                  </Col>
                  <Col
                    xs={4}
                    className="d-flex"
                    onMouseEnter={() => {
                      this.setState({ historyHovered: true });
                    }}
                    onMouseLeave={() => {
                      this.setState({ historyHovered: false });
                    }}
                  >
                    <p className="m-auto">{average}</p>
                  </Col>
                </Row>
                <div className="buttons-quiz-container">
                  <button
                    className="btn btn-outline-secondary rounded-lg ml-auto my-auto m-btn mobile-quiz-button"
                    onClick={() => this.handleRetakeDailyQuiz(item.id)}
                    disabled={disabledRetakeButton}
                  >
                    {isInProgress ? (
                      <span className="font-italic"> In progress </span>
                    ) : (
                      <span>RE-TAKE</span>
                    )}
                  </button>
                  <button
                    className="btn btn-outline-secondary rounded-lg ml-auto my-auto m-btn mobile-quiz-button"
                    onClick={() => this.handleReviewDailyQuiz(item.id)}
                    disabled={disabledReviewButton}
                  >
                    REVIEW
                  </button>
                  <button
                    className="btn btn-outline-secondary rounded-lg ml-auto my-auto m-btn mobile-quiz-button"
                    onClick={() => this.handleReviewLastDailyQuiz(item.id)}
                    disabled={disabledReviewButton}
                  >
                    REVIEW LAST QUIZ
                  </button>
                </div>
                {dailyHistoryList.length !== index + 1 && (
                  <hr className="row-divider" />
                )}
              </div>
            </React.Fragment>
          );
        case 'EARNED':
          return (
            <React.Fragment key={item.id}>
              {disabledRetakeButton && disabledReviewButton && (
                <QuizDisabledTooltip />
              )}
              <div className="m-0 p-0">
                <Row className="history-row">
                  <Col xs={8} className="d-flex m-btn-container">
                    <p className="mt-auto mb-auto">
                      {this.convertDate(item.date)}
                    </p>
                  </Col>
                  <Col xs={4} className="d-flex">
                    <p className="m-auto">{formatNumber(item.earned)}pts</p>
                  </Col>
                </Row>
                <div className="buttons-quiz-container">
                  <button
                    className="btn btn-outline-secondary rounded-lg ml-auto my-auto m-btn mobile-quiz-button"
                    onClick={() => this.handleRetakeDailyQuiz(item.id)}
                    disabled={disabledRetakeButton}
                  >
                    {isInProgress ? (
                      <span className="font-italic"> In progress </span>
                    ) : (
                      <span>RE-TAKE</span>
                    )}
                  </button>
                  <button
                    className="btn btn-outline-secondary rounded-lg ml-auto my-auto m-btn mobile-quiz-button"
                    onClick={() => this.handleReviewDailyQuiz(item.id)}
                    disabled={disabledReviewButton}
                  >
                    REVIEW
                  </button>
                  <button
                    className="btn btn-outline-secondary rounded-lg ml-auto my-auto m-btn mobile-quiz-button"
                    onClick={() => this.handleReviewLastDailyQuiz(item.id)}
                    disabled={disabledReviewButton}
                  >
                    REVIEW LAST QUIZ
                  </button>
                </div>
                {dailyHistoryList.length !== index + 1 && (
                  <hr className="row-divider" />
                )}
              </div>
            </React.Fragment>
          );
        default:
          return false;
      }
    });

    return quizHistory;
  }

  render() {
    const quizHistoryDesktop = this.renderHistoryDesktop();
    const quizHistoryMobile = this.renderHistoryMobile(
      this.state.currentSelectOption,
    );

    return (
      <div className="daily-quiz-history-container m-0 p-0">
        {((this.props.loadingDailyHistory &&
          this.props.dailyQuizHistory.dailyHistoryList.length === 0) ||
          (this.props.loadingDailyHistory &&
            this.props.dailyQuizHistory.dailyHistoryList.length > 0)) && (
          <div className="daily-quiz-history-content pt-4 pl-3 pr-3">
            <h4 className="mb-4">Daily Quiz History</h4>
            <div className="loading-history-gif-container">
              <CircularLoading className="loading-history-gif" />
            </div>
          </div>
        )}
        {this.props.loadingReviewDailyQuiz &&
          this.props.dailyQuizHistory.dailyHistoryList.length !== 0 && (
            <div className="daily-quiz-history-content pt-4 pl-3 pr-3">
              <h4 className="mb-4">Loading quiz...</h4>
              <div className="loading-history-gif-container">
                <CircularLoading className="loading-history-gif" />
              </div>
            </div>
          )}
        {!this.props.loadingReviewDailyQuiz &&
          !this.props.loadingDailyHistory &&
          this.props.dailyQuizHistory.dailyHistoryList.length > 0 && (
            <div
              className="daily-quiz-history-content pt-4 pl-3 pr-3"
              id="daily-quiz-history-content"
            >
              <h4 className="mb-4">Daily Quiz History</h4>
              <Row className="table-header mb-3">
                <Col xs={7} md={7} className="d-flex">
                  <p className="mt-auto mb-auto">DATE</p>
                </Col>

                <Desktop>
                  <Col
                    xs={5}
                    md={5}
                    className="text-center"
                    onMouseEnter={() => {
                      this.setState({ historyHovered: true });
                    }}
                    onMouseLeave={() => {
                      this.setState({ historyHovered: false });
                    }}
                  >
                    <Row>
                      <Col xs={3} className="p-0 d-flex">
                        <p className="m-auto">LAST QUIZ</p>
                      </Col>
                      <Col xs={3} className=" p-0 d-flex">
                        <p className="m-auto">MY SCORE</p>
                      </Col>
                      <Col xs={3} className=" p-0 d-flex">
                        <p className="m-auto">AVERAGE</p>
                      </Col>
                      <Col xs={3} className=" p-0 d-flex">
                        <p className="m-auto">EARNED</p>
                      </Col>
                    </Row>
                  </Col>
                </Desktop>

                <Mobile>
                  <Col xs={5} md={5} className="text-center">
                    <Dropdown
                      className="select-container ml-auto mr-auto"
                      isOpen={this.state.dropdownIsOpen}
                      toggle={this.handleDopdownClick}
                    >
                      <DropdownToggle
                        name="toggle"
                        className="week-selector pl-2 pr-2"
                      >
                        <span>{this.state.currentSelectOption}</span>{' '}
                        {this.state.dropdownIsOpen ? (
                          <i className="icon-expand select-icon rotate down" />
                        ) : (
                          <i className="icon-expand select-icon rotate" />
                        )}
                      </DropdownToggle>
                      <DropdownMenu
                        onClick={this.handelSelectOnClick}
                        className="mt-3 select-dropdown-menu"
                      >
                        <DropdownItem
                          name="SCORE"
                          value="score"
                          className={
                            this.state.currentSelectOption === 'SCORE'
                              ? 'selected-option'
                              : ''
                          }
                        >
                          Score
                        </DropdownItem>
                        <DropdownItem
                          name="AVERAGE"
                          value="average"
                          className={
                            this.state.currentSelectOption === 'AVERAGE'
                              ? 'selected-option'
                              : ''
                          }
                        >
                          Average
                        </DropdownItem>
                        <DropdownItem
                          name="EARNED"
                          value="earned"
                          className={
                            this.state.currentSelectOption === 'EARNED'
                              ? 'selected-option'
                              : ''
                          }
                        >
                          Earned
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </Col>
                </Mobile>
              </Row>
              <Desktop>{quizHistoryDesktop}</Desktop>
              <Mobile>{quizHistoryMobile}</Mobile>
            </div>
          )}
        {!this.props.loadingReviewDailyQuiz &&
          !this.props.loadingDailyHistory &&
          this.props.dailyQuizHistory.dailyHistoryList.length === 0 && (
            <div className="daily-quiz-history-content pt-4 pl-3 pr-3">
              <h4 className="mb-4">Daily Quiz History</h4>
              <div className="no-results-container">
                You haven&apos;t done any daily quizzes yet
              </div>
            </div>
          )}
        <hr />

        {!this.props.loadingDailyHistory &&
          this.props.dailyQuizHistory.dailyHistoryList.length > 0 && (
            <div className="text-center load-more-section container">
              <p
                onClick={() => this.handleLoadMore()}
                className={
                  this.props.dailyQuizHistory.dailyHistoryList.length >=
                  this.props.dailyQuizHistory.totalHistoryItems
                    ? 'disabled'
                    : ''
                }
              >
                LOAD MORE
              </p>
            </div>
          )}
      </div>
    );
  }
}

DailyQuizHistoryView.propTypes = {
  batch: PropTypes.number.isRequired,
  dailyQuizHistory: PropTypes.object.isRequired,
  getDailyQuizHistory: PropTypes.func.isRequired,
};
export default DailyQuizHistoryView;
